import {
  CircleCheck,
  Euro,
  Phone,
  ShieldAlert,
  Target,
  User,
} from "lucide-react";
import React from "react";
import { FaRegNewspaper } from "react-icons/fa";
import { useGetDashboardStats, useListUser } from "../../../hooks/api/user-table/hooks";
import UserTableList from "../users/UserTable";

type DashboardCard = {
  title: string;
  count: number;
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
};


interface Props {
  allowURLStateUpdate?: boolean;
}

const Dashboard: React.FC<Props> = ({ allowURLStateUpdate = true }) => {
  const {
    data,
    refetchWithQuery: refetch,
    isFetching,
  } = useListUser({ page: 1, limit: 10 });

  const { data: statsRes, isLoading: statsLoading } = useGetDashboardStats();

  const stats = statsRes?.data;

  const cards: DashboardCard[] = [
    {
      title: "Total Users",
      count: stats?.total_users ?? 0,
      icon: User,
    },
    {
      title: "Filling in progress",
      count: stats?.filling_in_progress ?? 0,
      icon: Target,
    },
    {
      title: "Completed Filling",
      count: stats?.completed_fillings ?? 0,
      icon: CircleCheck,
    },
    {
      title: "Pending Payments",
      count: stats?.pending_payments ?? 0,
      icon: Euro,
    },
  ];

  const qData = data?.qData ?? { page: 1, limit: 10 };

  const DEFAULT_NUQS_CONFIG = {
    throttleMs: !allowURLStateUpdate ? Infinity : 0,
  };

  return (
    <div>
      <h1 className="text-xl sm:text-3xl font-semibold sm:mb-4">
        Dashboard
      </h1>

      {/* Stats Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-3 xl:grid-cols-4 gap-5">
        {cards.map((card, index) => (
          <div
            key={index}
            className="
              primary_gradient
              text-white
              rounded-xl
              p-3
              shadow-md
              hover:shadow-lg
              transition-all
              duration-300
              cursor-pointer
            "
          >
            {/* TOP */}
            <div className="flex items-start gap-2">
              <h3 className="text-xl font-normal">{card.title}</h3>
            </div>

            {/* BOTTOM */}
            <div className="flex justify-between items-center mt-2">
              <span className="text-4xl">
                {card.count}
              </span>

              <div className="w-10 h-10 flex items-center justify-center">
                <card.icon className="w-[80px] h-[80px]" />
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* User Table */}
      <div className="mt-7">
        <h1 className="text-xl sm:text-3xl font-semibold sm:mb-4">
          New Users
        </h1>

        <UserTableList
          qData={qData}
          refetch={refetch}
          isFetching={isFetching}
          data={data?.data || []}
          allowURLStateUpdate={allowURLStateUpdate}
          DEFAULT_NUQS_CONFIG={DEFAULT_NUQS_CONFIG}
        />
      </div>
    </div>
  );
};

export default Dashboard;


